import React from 'react'
import type { ArticleUIData } from '@which/shared'

import classnames from 'classnames'

import { renderArticleElements } from './article-element-renderer'

export const articleBodyRenderer = (
  articleBodyTemplate: ArticleUIData[],
  additionalClasses = '',
  additionalInfo?: {
    articleUrl?: string
    subVerticalSlug?: string
    context?: string
    title?: string
    showFreeAccountLock?: boolean
    userLoggedIn?: boolean
  }
) => (
  <div className={classnames('article-wrapper', additionalClasses)}>
    {renderArticleElements(articleBodyTemplate, additionalInfo)}
  </div>
)
